import { paths } from "~/router/paths";

export const redirectRoutes = [
  { path: paths.settings.index, to: paths.settings.plans },
  { path: paths.reviews.index, to: paths.app.home },
];
